var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-upload',{attrs:{"label":_vm.label,"loading":_vm.loading,"accept":_vm.accept},on:{"fileChanged":_vm.fileChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }